module.exports = __webpack_public_path__ + "static/stevemadden-logo-c90cbb1d0446aff2911af955361ea016.png";